//
// webPollUrl
//
import config from './config';

const webPollUrl = (qrid) => (`${config.anon.www.corporate.home}web/poll/${qrid}`);

export default webPollUrl;
